module.exports = __webpack_public_path__ + "static/media/img_flipCards-05.82aee072.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/flipbox/img_flipCards-05.png
// module id = 440
// module chunks = 4